import * as tslib_1 from "tslib";
// Core components
import { AfterViewInit, EventEmitter, OnDestroy, OnInit } from '@angular/core';
// Third party components
import { MatDialog } from "@angular/material";
import { FieldType } from '@ngx-formly/material';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { AddSupplierDialogComponent } from 'src/app/modules/suppliers/components/add-supplier-dialog/add-supplier-dialog.component';
import { HelperService } from 'src/app/shared/services/helper.service';
// Custom components
// @see https://stackblitz.com/edit/angular-g9txuh-zysdfi?file=src/app/autocomplete-type.component.ts
var AutocompleteSupplierTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AutocompleteSupplierTypeComponent, _super);
    function AutocompleteSupplierTypeComponent(dialog, helperService) {
        var _this = _super.call(this) || this;
        _this.dialog = dialog;
        _this.helperService = helperService;
        _this.onDestroy$ = new Subject();
        _this.search$ = new EventEmitter();
        _this.options$ = new Observable();
        _this.optionsLoading = false;
        _this.optionsInput$ = new Subject();
        _this.addTag = function (name) {
            return new Promise(function (resolve) {
                var dialogRef = _this.dialog.open(AddSupplierDialogComponent, {
                    data: {
                        name: name
                    },
                    width: "900px",
                });
                dialogRef
                    .beforeClosed()
                    .pipe(take(1))
                    .subscribe(function (res) {
                    if (res && res.status) {
                        _this.value = res.supplier._id;
                        if (_this.formControl.parent.get('ragioneSocialeFornitore')) {
                            _this.formControl.parent.get('ragioneSocialeFornitore').setValue(res.supplier.companyName);
                        }
                        else if (_this.formControl.parent.get('nomeFornitoreCombustibile')) {
                            _this.formControl.parent.get('nomeFornitoreCombustibile').setValue(res.supplier.companyName);
                        }
                        var vatNumber = res.supplier.vatNumber ? " - " + res.supplier.vatNumber : '';
                        var city = (res.supplier.legalAddress && res.supplier.legalAddress.city) ? " - " + res.supplier.legalAddress.city : '';
                        resolve({ _id: res.supplier._id, companyName: res.supplier.companyName });
                    }
                    resolve('');
                }, function (err) {
                    _this.helperService.handleError(err);
                    resolve('');
                });
            });
        };
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AutocompleteSupplierTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.value = this.formControl.value;
        // Pre-populate formField options with given values (if any)
        var initialValues = [];
        var companyName = '';
        if (this.formControl.parent.get('ragioneSocialeFornitore') &&
            this.formControl.parent.get('ragioneSocialeFornitore').value !== '') {
            companyName = this.formControl.parent.get('ragioneSocialeFornitore').value;
        }
        else if (this.formControl.parent.get('nomeFornitoreCombustibile') &&
            this.formControl.parent.get('nomeFornitoreCombustibile').value !== '') {
            companyName = this.formControl.parent.get('nomeFornitoreCombustibile').value;
        }
        if (this.value && companyName) {
            initialValues.push({ _id: this.value, companyName: companyName });
        }
        if (!this.to.minTermLength) {
            this.to.minTermLength = 0;
        }
        this.options$ = concat(of(initialValues), this.optionsInput$.pipe(takeUntil(this.onDestroy$), // auto-unsubscribe on onDestroy()
        debounceTime(500), // max 1 query every 350 milliseconts
        tap(function () { return _this.optionsLoading = true; }), // Start loader
        distinctUntilChanged(), // Eliminate duplicate values
        switchMap(function (term) {
            var options = {
                general: term,
            };
            if (typeof _this.to.getAll !== 'undefined') {
                options.getAll = _this.to.getAll;
            }
            if (!_this.to.search$) {
                _this.optionsLoading = false;
                if (options && Array.isArray(options) && options.length) {
                    return options;
                }
                return [];
            }
            return _this.to.search$(0, 10, '', '', options)
                .pipe(map(function (res) {
                if (res.status) {
                    if (res.data.items) {
                        return res.data.items;
                    }
                    if (res.data && Array.isArray(res.data)) {
                        res.data.forEach(function (data) {
                            var vatNumber = data.vatNumber ? " - " + data.vatNumber : '';
                            var city = (data.legalAddress && data.legalAddress.city) ? " - " + data.legalAddress.city : '';
                            data.shortCompanyName = data.companyName;
                            data.companyName = "" + data.companyName + vatNumber + city;
                        });
                        return res.data;
                    }
                }
                return [];
            }), catchError(function () { return of([]); }), // empty list on error
            tap(function () { return _this.optionsLoading = false; }));
        })));
    };
    /**
     * Handle afterViewInit of this component
     *
     * @since 1.0.0
     */
    AutocompleteSupplierTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Handle ngOnDestroy of this component
     *
     * @since 1.0.0
     */
    AutocompleteSupplierTypeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.onDestroy$.complete();
    };
    /**
     * Fired every time model data changes
     *
     * @param {*} data new model data
     */
    AutocompleteSupplierTypeComponent.prototype.onChange = function (data) {
        if (data && data.shortCompanyName) {
            if (this.formControl.parent.get('ragioneSocialeFornitore')) {
                this.formControl.parent.get('ragioneSocialeFornitore').setValue(data.shortCompanyName);
            }
            else if (this.formControl.parent.get('nomeFornitoreCombustibile')) {
                this.formControl.parent.get('nomeFornitoreCombustibile').setValue(data.shortCompanyName);
            }
        }
        else if (data && data.companyName) {
            if (this.formControl.parent.get('ragioneSocialeFornitore')) {
                this.formControl.parent.get('ragioneSocialeFornitore').setValue(data.companyName);
            }
            else if (this.formControl.parent.get('nomeFornitoreCombustibile')) {
                this.formControl.parent.get('nomeFornitoreCombustibile').setValue(data.companyName);
            }
        }
        if (typeof this.to.callback === 'function') {
            this.to.callback(data);
        }
    };
    return AutocompleteSupplierTypeComponent;
}(FieldType));
export { AutocompleteSupplierTypeComponent };
